<template>
	<div class='register-component'>

		<div class='register-form-box-outer'>
			<div class='register-form-box'>

				<table>
					<tbody>
						<tr>
							<td class='label-col'>Дата обследования</td>
							<td><input type="date" v-model='observationDate'></td>
						</tr>
					</tbody>
                </table>
                <div class='input-files'>
                <input type="button" value="Открыть XML" onclick="document.getElementById('import-xml').click();" />
                <input type="file" multiple="multiple" accept=".xml" style="display:none;" id="import-xml" ref="import-xml" name="file" @change.prevent.stop="onFilesChange($event.target)"/>
                <input type="button" value="Очистить" :disabled="!files" @click="clearFilesList" />
                <span v-for="f in files">
                    {{f.name}} <br>
                </span>
                </div>
				<div class='register-btn-block'>
					<router-link to='/'>Вернуться</router-link>
					<button @click='importXml' class='register-btn' :disabled="!files || !observationDate || buttonDisabled">Загрузить выбранные карточки</button>
				</div>
            </div>
		</div>

	</div>
</template>

<script>
	import router from '@/router';
	const REGISTER = process.env.VUE_APP_ROOT_API + 'auth/register.php';
    const LOAD_XML_INSPECTION = process.env.VUE_APP_ROOT_API + 'load_file/import_inspection.php';

	import { mapState } from 'vuex';

	export default {
		name: 'RegisterComponent',
		data: () => ({
			observationDate: null,
			user_name: null,
			filial_id: null,
			user_post: null,
            files: null,
			buttonDisabled: false
		}),
		computed: {
			...mapState({
				info_filials: state => state.catalogs.info_filials
			})
		},
		methods: {
            importXml() {
				this.buttonDisabled = true
                const form = new FormData();
				form.append('observ_date', this.observationDate);
                this.files.forEach((element) => {
                  form.append('file[]', element);  
                })
				fetch(LOAD_XML_INSPECTION, {
					method: 'post',
					body: form,
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					console.log(res)
					this.buttonDisabled = false
					if ( res.res == 0 && res.errors.length == 0) {
						this.$toast.add({severity: 'success', detail: 'Успешный импорт', life: 10000});
					}
					else {
						res.errors.forEach((error) => {
							this.$toast.add({severity: 'error', detail: `Файл: ${error.filename} ошибка: ${error.text}`, life: 10000});
						})
					}
				})
				.catch(error => {
					this.$toast.add({severity: 'error', detail: `Критическая ошибка: ${error}`, life: 10000});
					this.buttonDisabled = false
				});
            },
            onFilesChange(target) {
                    this.files = target.files;
            },
			clearFilesList() {
				this.$refs['import-xml'].value=''
				this.files = null
			},
			register() {

				let isIncorrect = false;

				if (this.login === null || this.login === '') {
					this.$toast.add({severity:'warn', detail: 'Необходимо ввести логин', life: 10000});
					isIncorrect = true;
				}
				if (this.user_name === null || this.user_name === '') {
					this.$toast.add({severity:'warn', detail: 'Необходимо ввести имя пользователя', life: 10000});
					isIncorrect = true;
				}
				if (this.filial_id === null || this.filial_id === '') {
					this.$toast.add({severity:'warn', detail: 'Необходимо выбрать филиал', life: 10000});
					isIncorrect = true;
				}
				if (this.user_post === null || this.user_post === '') {
					this.$toast.add({severity:'warn', detail: 'Необходимо ввести должность', life: 10000});
					isIncorrect = true;
				}
				if (isIncorrect) {
					return;
				}

				const form = new FormData();
				form.append('login', this.login);
				form.append('user_name', this.user_name);
				form.append('filial_id', this.filial_id);
				form.append('user_post', this.user_post);

				fetch(REGISTER, {
					method: 'post',
					body: form,
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					console.log(res)
					if ( res.user > 0) {
						this.$toast.add({severity: 'success', detail: 'Пользователь зарегистрирован (обновлен)', life: 10000});
					}
					if (res.code == 0) {
						this.$toast.add({severity: 'success', detail: 'Уведомление успешно отправлено на адрес электронной почты', life: 10000});
					} else {
						this.$toast.add({severity: 'error', detail: 'Письмо не отправлено', life: 10000});
					}
					
				})
				.catch(error => {
					this.$toast.add({severity: 'error', detail: 'Произошла ошибка', life: 10000});
				});
			}
		},
		created() {
			const catalogs = [ 'info_filials' ];
			this.$store.dispatch('loadCatalogs', catalogs);
		},
	};
</script>

<style scoped>
    .input-files {
        display: grid;
    }

	.register-component {
		height: 100vh;
		position: relative;
	}

	.register-form-box-outer {
		height: 100%;
		width: 560px;
		margin: auto;

		/*background-color: black;*/
		padding: 40px;

	}

	.register-form-box table {
		width: 100%;
	}

	.register-form-box {
        //overflow-y: scroll;
		position: relative;
		//top: 20%;
		//transform: translateY(-100%);
	}

	/*.back-to-login-block {
		position: absolute;
		left: 20px;
		bottom: 20px;
	}*/

	select {
		width: 100%;
	}

	table td {
		padding-bottom: 10px;
	}

	.label-col {
		text-align: right;
		padding-right: 20px;
		font-weight: bold;
	}

	input,
	select {
		height: 2rem;
		padding: 0 0.5rem;
	}

	input,
	select,
	table,
	button,
	.register-form-box {
		font-size: 1rem;
	}

	.register-btn-block {
		margin-top: 20px;
	}

	.register-btn-block::after {
		display: table;
		content: '';
		clear: both;
	}

	.register-btn {
		float: right;
	}

</style>